import { jsx as u } from "react/jsx-runtime";
import { createContext as g, memo as d, useContext as n } from "react";
function m(s) {
  return (r, e) => {
    for (const t of s)
      if (t.shouldHandleImage(r, e))
        return t.process(r, e);
    throw new Error(`No ImageProcessor found for image URL '${r}'`);
  };
}
const c = g(void 0), f = d(
  (s) => {
    const r = m(s.processors);
    return /* @__PURE__ */ u(c.Provider, { value: r, children: s.children });
  }
);
f.displayName = "ImageProcessorProvider";
const I = () => {
  const s = n(c);
  if (!s)
    throw new Error(
      "useImageProcessor must be used within an ImageProcessorProvider"
    );
  return s;
};
class y {
  constructor(r) {
    this.baseUrl = r;
  }
  process(r, e) {
    const t = { format: "auto" };
    e.width && !e.height ? t.width = e.width : e.width && e.height && (t.width = e.width, t.height = e.height), e.quality && (t.quality = e.quality), e.gravity && (typeof e.gravity == "string" ? t.gravity = e.gravity : t.gravity = `${e.gravity.x}x${e.gravity.y}`);
    const o = Object.keys(t).reduce((a, i) => (a.push(`${i}=${t[i]}`), a), []).join(",");
    return `${this.baseUrl}/cdn-cgi/image/${o}/${r}`;
  }
  shouldHandleImage(r, e) {
    return !0;
  }
}
class $ {
  process(r, e) {
    return r;
  }
  shouldHandleImage(r) {
    return !0;
  }
}
class v {
  constructor(r) {
    this.baseUrl = r;
  }
  process(r, e) {
    return `${this.baseUrl}/${r}`;
  }
  shouldHandleImage(r, e) {
    return !0;
  }
  getDimensions(r, e) {
    return { width: 0, height: 0 };
  }
}
const h = class l {
  constructor() {
  }
  process(r, e) {
    let { width: t, height: o } = e;
    if (t === void 0 && o === void 0)
      throw new Error(
        "PlaceholditImageProcessor requires at least width or height to be set"
      );
    return t && o === void 0 ? o = t : o && t === void 0 && (t = o), `https://placehold.it/${t}x${o}`;
  }
  shouldHandleImage(r, e) {
    return r === l.imageUrl;
  }
};
h.imageUrl = "placeholdit";
let x = h;
class p {
  constructor() {
  }
  process(r, e) {
    const t = ["m"];
    e.width && !e.height ? t.push(`${e.width}x0`) : e.width && e.height && t.push(`${e.width}x${e.height}`);
    const o = e.quality ?? 80;
    return t.push(`filters:quality(${o})`), [r, ...t].join("/");
  }
  shouldHandleImage(r, e) {
    try {
      const t = new URL(r);
      return /storyblok\.com$/.test(t.host);
    } catch (t) {
      return console.error(`Couldn't parse imageURL '${r}'`, t), !1;
    }
  }
}
export {
  y as CloudflareImageProcessor,
  $ as EchoImageProcessor,
  f as ImageProcessorProvider,
  v as ImgproxyImageProcessor,
  x as PlaceholditImageProcessor,
  p as StoryblokImageProcessor,
  m as imageProcessorChain,
  I as useImageProcessor
};
